import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Icon} from '@thryvlabs/maverick'
import {
  getCatalogCollapseStatus,
  updateCatalogCollapseStatus,
} from '../../../../../../../app-store/kp11CartSlice'
import {
  CardPlanHeaderStyle,
  CardPlanBodyStyle,
} from '../../kp-11Link-catalog-cards-style'
import {KP11LinkCatalogCardWrapperStyle} from '../../kp-11Link-catalog-cards-style'
import {fetchPlanIcon} from '../../../../../../../utils/fetch-plan-icon'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import {formatPrice} from '../../../../../../../utils/currency-format'

const GenericKP11CardSelectInput = ({
  name,
  price,
  isExpanded: isExpandedProp,
  groupKey,
  itemCode,
  onSelect,
  label,
  options = [],
  value,
  placeholder,
  isDisabled = false,
  addToCartDisabled = false,
  onSave,
  billingType = 'Billed Monthly',
  selectedCountry = 'US',
}) => {
  const dispatch = useDispatch()
  const cardCollapseStatus = useSelector(getCatalogCollapseStatus)

  const collapseKey = itemCode || name || groupKey || 'generic'
  const isExpanded = Boolean(cardCollapseStatus?.[collapseKey])

  useEffect(() => {
    // If parent passes an initial expanded state, sync it to redux
    if (typeof isExpandedProp === 'boolean' && isExpandedProp !== isExpanded) {
      dispatch(updateCatalogCollapseStatus(collapseKey))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpandedProp])

  const handleSelectChange = e => {
    onSelect(e.target.value)
  }

  return (
    <KP11LinkCatalogCardWrapperStyle>
      <div
        className={`d-flex flex-column w-100 ${
          isDisabled ? 'disable-with-opacity' : ''
        }`}
      >
        <CardPlanHeaderStyle
          onClick={() =>
            !isDisabled && dispatch(updateCatalogCollapseStatus(collapseKey))
          }
        >
          <div className="card-heading justify-content-between w-100">
            <div className="d-flex flex-row align-items-center gap-4">
              <div className="card-icon">
                <img
                  src={fetchPlanIcon(name)?.icon || ''}
                  alt="plan logo"
                  className="options-logo rounded"
                />
              </div>
              <div className="card-title-text">{name || 'Item'}</div>
            </div>
            <div>
              <Icon
                type={'solid'}
                variant={isExpanded ? 'caretDown' : 'caretRight'}
                height={'15'}
                width={'15'}
                color={'#FF6100'}
              />
            </div>
          </div>
        </CardPlanHeaderStyle>

        {isExpanded && (
          <CardPlanBodyStyle>
            <div
              className="card-plan-subText"
              style={{paddingTop: '1rem', fontWeight: 'bold'}}
            >
              Select a subscription plan
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <div className="plan-item-price">
                    {formatPrice(price ?? 0, 1, '', selectedCountry)}
                  </div>
                  <div className="card-plan-subText">{billingType}</div>
                </div>
              </div>

              <div
                className="custom-field-wrapper"
                style={{marginTop: '12px', width: '100%'}}
                onClick={e => e.stopPropagation()}
              >
                <label className="custom-field-label">
                  <span className="custom-field-label-text">
                    {label} <span style={{color: 'red'}}>*</span>{' '}
                  </span>
                  <select
                    className="custom-field-select"
                    value={value}
                    onChange={handleSelectChange}
                  >
                    <option value="">
                      {placeholder || 'Select an option'}
                    </option>
                    {options.map((option, index) => (
                      <option key={option.value || index} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="d-flex" style={{marginTop: 8}}>
                <button
                  type="button"
                  className="add-to-cart-button"
                  onClick={onSave}
                  disabled={!value || isDisabled || addToCartDisabled}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </CardPlanBodyStyle>
        )}
      </div>
    </KP11LinkCatalogCardWrapperStyle>
  )
}

export default GenericKP11CardSelectInput
